import React from "react";
import { connect } from "react-redux";

import TextChart from "../../../Charts/TextChart";

const TextoChequesEnCartera = (props) => {
  const {
    monto,
    cantidadCheques,
    loading,
    inClientInfo,
    clientSelected,
    error,
  } = props;

  return (
    <TextChart
      title={`Cheques en cartera`}
      bigAmount={monto}
      smallAmount={cantidadCheques}
      smallAmountTooltip={`Cant. cheques`}
      bigCurrency
      noClient={!clientSelected && inClientInfo}
      loading={loading}
      imgSinDatos={error}
      onBodyClick={() => props.onBodyClick()}
      cursorPointer
    />
  );
};

const mapStateToProps = (state) => {
  return {
    monto: state.cheques.chequesEnCartera.monto,
    cantidadCheques: state.cheques.chequesEnCartera.cantidadCheques,
    loading: state.cheques.chequesEnCartera.loading,
    error: state.cheques.chequesEnCartera.error,
    clientSelected: state.clientes.clienteById.clientSelected,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(TextoChequesEnCartera);
